export const cz_CZ = {
  translation: {
    add_to_cart: "Přidat článek do košíku",
    save: "Uložit",
    load: "Načíst článek",
    title: "Konfigurace",
    type_key: "Typový klíč",
    start: "Spustit",
    generate_document: "Vytvořit datový list",
    sap_button: "Vytvořit článek v SAP",
    cad_button: "Vytvořit CAD data",
    reset_configuration: "Resetovat konfiguraci",
    show_additional_information: "Zobrazit další informace",
    sap_title: "SAP",
    close_configuration_button: "Zavřít",
    no_results_found: "Nebyly nalezeny žádné výsledky",
    load_configuration_dialog: {
      title: "Načíst konfiguraci – Nastavit parametry vyhledávání",
      cancel: "Zrušit",
      search: "Hledat",
      start_date: "Datum vytvoření od",
      end_date: "do",
      guid: "GUID",
      material_number: "Číslo materiálu",
      order_code: "Kód objednávky",
      creator: "Tvůrce",
      description: "Popis",
      info_artikel: "Info článek",
      short_text: "Krátký text",
      version: "Verze",
      status: "Stav",
      update_user: "Aktualizováno uživatelem",
      createdDate: "Datum vytvoření",
      saved_records: "Uložené záznamy",
      back: "Zpět",
      open: "Otevřít",
      rows_per_page: "Řádky na stránku:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(NAČTENÍ) selhalo (data jsou nesprávná nebo neúplná)",
      ERROR_SAVE_DATA_ERROR:
        "(ULOŽENÍ) selhalo (data jsou nesprávná nebo neúplná)",
      ERROR_LOAD_ID: "ID pro načtení nebylo nalezeno",
      ERROR_LOAD_ID_CONFIG: "Chyba konfigurátoru při načítání projektu",
      ERROR_LOADSTART_CONFIG: "Chyba konfigurátoru při spuštění",
      ERROR_MISSING_VALUES:
        "Obecná chybová zpráva, pokud ověření frontendových dat selže",
      ERROR_COOKIE_SERVICE_INITIAL: "Inicializace služby cookie selhala",
      ERROR_COOKIE_GENERAL: "Chyba ve službě cookie",
      ERROR_TOKEN_NOT_FOUND: "Token nebyl nalezen",
      ERROR_ID_BLOCKED: "Položka je upravována, změny nejsou možné",
      ERROR_DB_SAVE: "Chyba při ukládání dat do databáze",
      ERROR_LOAD_VALID: "Načtení konfigurace selhalo, data jsou neplatná",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "ID nebylo nalezeno, SAP kontrola selhala",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Nebyla nalezena žádná materiálová čísla pro ID ze shop ID",
      ERROR_DELETE_CONFIGURATION: "Chyba při mazání konfigurace",
      ERROR_DEFINITION_SECRET_JWT: "Chybí definice JWT",
      ERROR_PATH_NOT_DEFINED: "Cesta není definována",
      ERROR_BACKLINK_URL: "Zpětný odkaz není definován",
      ERROR_POSITIONDATA_EMPTY: "Údaje o pozici jsou prázdné",
      ERROR_SHOP_ID: "ID obchodu nenalezeno",
      ERROR_CADBOXDATA_EMPTY: "Nebyly nalezeny žádné údaje o CAD boxu",
      ERROR_NONE_LOAD_ID_FOUND: "Nebylo nalezeno žádné ID k načtení",
      ERROR_NONE_ACCEPTABLE_ID: "Nebylo nalezeno žádné přijatelné ID",
    },
    sap: {
      create_error: "Chyba při vytváření",
      create_success: "Úspěšně vytvořeno",
    },
    button: {
      save: "Uložit",
      cancel: "Zrušit",
    },
  },
};

export default cz_CZ;
